var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconAwesomeArrowLeftBack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.848,
    height: 17.394,
    viewBox: "0 0 17.848 17.394",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-arrow-left",
    "data-name": "Icon awesome-arrow-left",
    d: "M10.256,18.876l-.884.884a.952.952,0,0,1-1.35,0L.277,12.021a.952.952,0,0,1,0-1.35L8.021,2.928a.952.952,0,0,1,1.35,0l.884.884a.957.957,0,0,1-.016,1.366L5.44,9.751H16.888a.954.954,0,0,1,.956.956v1.275a.954.954,0,0,1-.956.956H5.44l4.8,4.573A.95.95,0,0,1,10.256,18.876Z",
    transform: "translate(0.004 -2.647)",
    fill: "#626262"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAwesomeArrowLeftBack);
export default __webpack_public_path__ + "static/media/Icon_awesome-arrow-left-back.9e4eaddda519f5589f55aada41b9d3e1.svg";
export { ForwardRef as ReactComponent };